import {
    getDetailTypeFromParamUrl,
    getPolicyRegulationDetailUrl,
    getPolicyRegulationsUrl,
    getThumbnailUrl
} from "./EndpointService.js";
import {API_METHODS, apiFetch, policyApiFetch, policyApiUpload} from "./ApiService.js";

export const getPolicyRegulations = async (token_arg) => {
    try {
        return await policyApiFetch(`${getPolicyRegulationsUrl}?per_page=1`, token_arg).then(async (response) => {
            return await policyApiFetch(`${getPolicyRegulationsUrl}?per_page=${response.total}`, token_arg);
        });
    } catch (error) {
        return null;
    }
};

export const getCountRegulations = async (token_arg) => {
    try {
        return await policyApiFetch(`${getPolicyRegulationsUrl}?per_page=1`, token_arg)
    } catch (error) {
        return null;
    }
};

export const getDetailTypeFromParam = async (token_arg, param) => {
    try {
        return await apiFetch(getDetailTypeFromParamUrl, token_arg, API_METHODS.POST, param);
    } catch (error) {
        return null;
    }
};

export const getDetailValueDoc = async (token_arg, id) => {
    try {
        return await policyApiFetch(`${getPolicyRegulationDetailUrl}/${id}/value_doc_final`, token_arg);
    } catch (error) {
        return null;
    }
};

export const getRegulationThumbnail = async (token_arg, id) => {
    const body = {id: id, type: "regulation"};
    try {
        return await apiFetch(getThumbnailUrl, token_arg, API_METHODS.POST, body);
    } catch (error) {
        return null;
    }
};

export const updateRegulationDetail = async (token_arg, id, body) => {
    try {
        return await policyApiFetch(`${getPolicyRegulationDetailUrl}/${id}`, token_arg, API_METHODS.PATCH, body);
    } catch (error) {
        return null;
    }
};

export const uploadRegulationDoc = async (token_arg, id, contentType, body) => {
    try {
        return await policyApiUpload(`${getPolicyRegulationDetailUrl}/${id}/value_doc_final`, token_arg, contentType, body);
    } catch (error) {
        return null;
    }
};
